import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../lib/auth";
import { onEvent } from "../lib/events";
import { markRead, noticeFrom, onNotificationTap, refreshUnread, seen, systemNotify, type OmniNotice } from "../lib/notify";
import { Icon } from "./Icon";

/** ADR-0031: banners for Omni notifications, and system notifications in the background. */
export function Notices() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState<OmniNotice[]>([]);

  useEffect(() => {
    if (!user) return;
    const off = onEvent((e) => {
      const n = noticeFrom(e);
      if (!n) return;
      if (n.notificationId) void refreshUnread().catch(() => undefined);
      if (document.visibilityState === "visible") {
        if (n.notificationId) void seen(n.notificationId);
        setItems((all) => [...all.slice(-2), n]);
        setTimeout(() => setItems((all) => all.filter((x) => x.id !== n.id)), 8000);
      } else {
        void systemNotify(n).catch(() => undefined);
      }
    });
    let offTap = () => {};
    void onNotificationTap((route) => nav(route)).then((f) => (offTap = f));
    return () => { off(); offTap(); };
  }, [user?.id, nav]);

  if (!items.length) return null;
  const dismiss = (id: number) => setItems((all) => all.filter((x) => x.id !== id));
  return (
    <div className="notices" role="status" aria-live="polite">
      {items.map((n) => (
        <div key={n.id} className="notice">
          <button className="notice-body" onClick={() => { dismiss(n.id); if (n.notificationId) void markRead(n.notificationId).catch(() => undefined); nav(n.route); }}>
            <span className="notice-ic"><Icon name="bell" size={18} /></span>
            <span className="notice-text">
              <strong>{n.title}</strong>
              {n.body && <span>{n.body}</span>}
            </span>
          </button>
          <button className="notice-close" aria-label="Dismiss" onClick={() => dismiss(n.id)}><Icon name="close" size={16} /></button>
        </div>
      ))}
    </div>
  );
}
